import Vue from 'vue'
import VueRouter, { RawLocation, Route } from 'vue-router'

import store from '../store/index'
import axios from 'axios'
import textTruncate from '../helpers/textTruncate'
import exchanges from '../helpers/exchangeTitle'

Vue.use(VueRouter)
import { appSettings } from '@/environment'

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('../views/index.vue'),
            meta: {
                standart: true,
                title: 'Bienvenido',
                description: ''
            }
        },
        {
            path: '/:country/text',
            component: () => import('../views/text.vue'),
            meta: {
                standart: true,
                title: 'Pruebas de ruta',
                description: appSettings.appName + ' es un cliente de Mapaprop Portal API, y fue desarrollado por el equipo de Mapaprop.com'
            }
        },
        {
            path: '/:country/acerca-de-nosotros',
            component: () => import('../views/about.vue'),
            meta: {
                standart: true,
                title: 'Nosotros - Misión',
                description: appSettings.appName + ' es un cliente de Mapaprop Portal API, y fue desarrollado por el equipo de Mapaprop.com para la difusion de bienes raices comerciazliados por profesionales en diversos países.'
            }
        },
        {
            path: '/:country/terminos-y-condiciones',
            component: () => import('../views/terms.vue'),
            meta: {
                standart: true,
                title: 'Términos y condiciones',
                description: 'Los Términos y Condiciones se encuentran disponibles para usuarios y clientes.'
            }
        },
        {
            path: '/:country/politica-de-privacidad',
            component: () => import('../views/privacy.vue'),
            meta: {
                standart: true,
                title: 'Política de privacidad',
                description: 'La política de Privacidad se encuentran disponibles para usuarios y clientes.'
            }
        },
        {
            path: '/:country/contacto',
            component: () => import('../views/contact.vue'),
            meta: {
                standart: true,
                title: 'Contacto',
                description: 'Envia tu consulta. Puedes escribirnos un mensaje y procuraremos responder lo antes posible.'
            }
        },
        {
            path: '/:country',
            component: () => import('../views/home.vue'),
            meta: {
                vuex: true,
                title: 'tHome',
                description: 'dHome'
            }
        },
        {
            path: '/:country/buscar/*',
            component: () => import('../views/properties.vue'),
            meta: {
                properties: true,
                title: 'tSearch',
                description: 'dSearch'
            }
        },
        {
            path: '/:country/propiedad/*',
            component: () => import('../views/property.vue'),
            meta: {
                property: true
            }
        },
        {
            path: '*',
            component: () => import('../errors/404.vue'),
            meta: {
                standart: true,
                title: 'Página no encontrada',
                description: ''
            }
        }
    ]
})
// console.log(router)
// console.log(process.env.BASE_URL)




router.beforeEach(async (to, from, next) => {
    const standart = to.matched.some((record) => record.meta.standart)
    const vuex = to.matched.some((record) => record.meta.vuex)
    const property = to.matched.some((record) => record.meta.property)
    const properties = to.matched.some((record) => record.meta.properties)

    next()

    if (to.fullPath == '/') {
        store.dispatch('initApp', 'AR')
        next('/ar')
    }
    // {
    //     axios
    //         .get('https://api.ipstack.com/check?access_key=9c5ae013a2155928d2211207fbcc93b1')
    //         .then((response) => {
    //             const country = response.data.country_code
    //             console.log(country)
    //
    //             if (country === 'AR') {
    //                 store.dispatch('initApp', 'AR')
    //                 next('/ar')
    //             } else if (country === 'ES') {
    //                 store.dispatch('initApp', 'ES')
    //                 next('/es')
    //             } else if (country === 'UY') {
    //                 store.dispatch('initApp', 'UY')
    //                 next('/uy')
    //             } else if (country === 'CL') {
    //                 store.dispatch('initApp', 'CL')
    //                 next('/cl')
    //             } else {
    //                 store.dispatch('initApp', 'ES')
    //                 next('/es')
    //             }
    //         })
    //         .catch((error) => {
    //             store.dispatch('initApp', 'AR')
    //             console.error(error)
    //             next('/ar')
    //         })
    // }
    else {
        const country = to.fullPath.replace('/', '').split('/')[0]
        if (country === 'ar') {
            store.dispatch('initApp', 'AR')
        } else if (country === 'es') {
            store.dispatch('initApp', 'ES')
        } else if (country === 'uy') {
            store.dispatch('initApp', 'UY')
        } else if (country === 'cl') {
            store.dispatch('initApp', 'CL')
        }
    }


    const capitalize = (string: string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    }

// este metodo pone el titulo en el documento (sería un setTitle)
    const filterUrl = (param: any, type: undefined | any = undefined) => {
        const country = to.params.country
        let first = param.split('_')[0]
        let second = first.split('-')
        second.shift()
        let result = null

        if (type !== undefined) {
            for (const exchange of exchanges) {
                if (exchange.country == country) {
                  // console.log(exchange.country)

                    for (const data of exchange.data) {
                        if (data.key == type) {
                          // console.log(data.key)

                            for (const text of data.texts) {
                                if (text.singular == second.join(' ')) {
                                    result = text.plural
                                    // console.log(result)

                                }
                            }
                        }
                    }
                }
            }
        } else {
            result = second.join(' ')
        }
        return result
    }

    let propertiesArrayTitle = []

    if (to.matched[0].path == '/:country/buscar/*') {
        const params = to.params.pathMatch.split('/').filter(e => e != "")

        let type: any = undefined
        let operation: any = undefined
        let size: any = 20
        // let from: any = undefined
        let bedrooms: any = undefined
        let bathrooms: any = undefined
        let stateId: any = undefined
        let countyId: any = undefined
        let cityId: any = undefined
        let priceFrom: any = undefined
        let priceTo: any = undefined
        let currency: any = undefined

        for (const param of params) {
            if (param.includes('operacion')) {
                propertiesArrayTitle.push(filterUrl(param, 'operation'))
                operation = param.split('_')[1]
            } else if (param.includes('tipo')) {
                propertiesArrayTitle.push(filterUrl(param, 'type'))
                type = param.split('_')[1]
            } else if (param.includes('precio-min')) {
                priceFrom = param.split('_')[1]
            } else if (param.includes('precio-max')) {
                priceTo = param.split('_')[1]
            } else if (param.includes('moneda')) {
                currency = param.split('_')[1]
            } else if (param.includes('zona')) {
                propertiesArrayTitle.push(filterUrl(param))
                stateId = param.split('_')[1].split('-')[0]
                countyId = param.split('_')[1].split('-')[1]
                cityId = param.split('_')[1].split('-')[2]
            } else if (param.includes('dormitorios')) {
                bedrooms = param.split('_')[1]
            } else if (param.includes('banos')) {
                bathrooms = param.split('_')[1]
            }   else {
              propertiesArrayTitle.push('Búsqueda de propiedades')
            }
        }

        store.commit('requests/propertiesHandler', null)

        setTimeout(() => {
            store.commit('paramsHandler', {
                type: type,
                operation: operation,
                size: size,
                from: from,
                bedrooms: bedrooms,
                bathrooms: bathrooms,
                stateId: stateId,
                countyId: countyId,
                cityId: cityId,
                priceFrom: priceFrom,
                priceTo: priceTo,
                currency: currency
            })

            // console.group("src/router/index.ts")
            // console.log("store.getters: ", store.getters)
            // console.groupEnd()


            store.dispatch('requests/propertiesRequest', false)
        }, 500)
    }

    const metas = document.querySelectorAll('meta')

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === 'description') {
            // @ts-ignore
            metas[i].parentNode.removeChild(metas[i])
        }
    }

    let meta = document.createElement('meta')

    if (property) {
        const hash = to.params.pathMatch.split('/')[1]
        store
        .dispatch('requests/propertyRequest', hash)
            .then((response) => {
                document.title = `${capitalize(response.title)} - ${appSettings.appName}`
                meta.name = 'description'
                meta.setAttribute('content', textTruncate(capitalize(response.description), 150))
                const head = document.querySelector('head')
                if (head) head.appendChild(meta)
                next()
            })
            .catch((error) => { })
    } else if (properties) {
        document.title = `${propertiesArrayTitle[0]} de ${propertiesArrayTitle[1]} en ${propertiesArrayTitle[2]} - ${appSettings.appName}`
        meta.name = 'description'
        meta.setAttribute('content', textTruncate(store.getters['countries/country'].head[to.meta.description], 150))

        const head = document.querySelector('head')
        if (head) head.appendChild(meta)
        next()
    } else if (vuex) {
        document.title = store.getters['countries/country'].head[to.meta.title]
        meta.name = 'description'
        meta.setAttribute('content', textTruncate(store.getters['countries/country'].head[to.meta.description], 150))
        const head = document.querySelector('head')
        if (head) head.appendChild(meta)
        next()
    } else if (standart) {
        document.title = `${to.meta.title} - ${appSettings.appName}`
        meta.name = 'description'
        meta.setAttribute('content', textTruncate(to.meta.description, 150))
        const head = document.querySelector('head')
        if (head) head.appendChild(meta)
        next()
    }
})

export default router
